module.exports = __webpack_public_path__ + "static/media/sound2.b1e1008f.mp3";